import { render, staticRenderFns } from "./Jtopo.vue?vue&type=template&id=b0a64f24&scoped=true&"
import script from "./Jtopo.vue?vue&type=script&lang=js&"
export * from "./Jtopo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a64f24",
  null
  
)

export default component.exports